export default {
  currentImage: state => state.currentImage,
  productInspiration: state => state.productInspiration,
  productCross: state => state.productCross,
  productComplementary: state => state.productComplementary,
  productXsellAddToCart: state => state.productXsellAddToCart,
  variants: state => state.variants,
  product: state => state.product,
  breadcrumb: state => {
    var _state$product;
    return ((_state$product = state.product) === null || _state$product === void 0 ? void 0 : _state$product.breadcrumbDisplay) || null;
  },
  productRR: state => state.productRR
};